import { SheetSelectRow } from '../../SheetSelectRow'
import { FilterSheetMenuItem } from '../FilterSheetMenuItem'

import styles from '../../FiltersMobileSheet.module.scss'

type FilterSheetSelectRowProps<TMenu extends string, TValue extends string> = {
  displayValue: string
  menuItemTestIdPrefix?: string
  menuKey: TMenu
  onSelect: (value: TValue) => void
  openMenu: TMenu | null
  options: readonly { value: string; label: string }[]
  rowLabel: string
  rowTestId?: string
  selectedValue: TValue
  setOpenMenu: (menu: TMenu | null) => void
}

export function FilterSheetSelectRow<TMenu extends string, TValue extends string>({
  rowLabel,
  displayValue,
  menuKey,
  openMenu,
  setOpenMenu,
  options,
  selectedValue,
  onSelect,
  rowTestId,
  menuItemTestIdPrefix,
}: FilterSheetSelectRowProps<TMenu, TValue>) {
  return (
    <div data-testid={rowTestId}>
      <SheetSelectRow
        rowLabel={rowLabel}
        displayValue={displayValue}
        menuOpen={openMenu === menuKey}
        onMenuOpenChange={(open) => setOpenMenu(open ? menuKey : null)}
      >
        <div className={styles.menuItems}>
          {options.map((option) => (
            <FilterSheetMenuItem
              key={option.value}
              label={option.label}
              isSelected={selectedValue === option.value}
              onSelect={() => onSelect(option.value as TValue)}
              testId={menuItemTestIdPrefix ? `${menuItemTestIdPrefix}-${option.value}` : undefined}
            />
          ))}
        </div>
      </SheetSelectRow>
    </div>
  )
}
